import { render } from "./ProviderSearch.vue?vue&type=template&id=5744db8c&scoped=true"
import script from "./ProviderSearch.vue?vue&type=script&lang=js"
export * from "./ProviderSearch.vue?vue&type=script&lang=js"

import "./ProviderSearch.vue?vue&type=style&index=0&id=5744db8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5744db8c"]])

export default __exports__